export const bokaMeraActionTypes = {
    GET_INVOICE_DATES: "GET_INVOICE_DATES",
    GET_ORDER_ERRORS: "GET_ORDER_ERRORS",
}